<script>
  import { createEventDispatcher, onDestroy } from 'svelte'
  import { fade } from 'svelte/transition'

  // import { Router, Link, navigate } from 'svelte-routing'
  import CBuffer from 'CBuffer'
  import { max, mean } from './../../lib/simple-statistics/dist/simple-statistics.mjs'
  // simple statistics lib has been monkeypatched:
  // in its package.json, replace the contents of the 'exports' field with
  //  ".": "./dist/simple-statistics.mjs",
  //  "./package.json": "./package.json"

  import { TaikoAudio as Audio } from './../TaikoAudio.js'
	import { activePage, staticPath } from './../stores.js';

  import RadialVisualizer from './../components/RadialVisualizer.svelte'
  import RadialAmplitudeVisualizer from './../components/RadialAmplitudeVisualizer.svelte'
  import DeckViewer from './../components/DeckViewer.svelte'
  import Stepper from './../components/Stepper.svelte'
  import KeyboardInputHandler from './../components/KeyboardInputHandler.svelte'

  
  import { TaikoDevice as Device} from './../TaikoDevice.js'
  
	Device.init()

  const dispatch = createEventDispatcher()

  // workaround for issue when Desktop Chrome pretends it has an accelerometer 
  const params = new URLSearchParams(window.location.search)
  if(params.has('keyboard')){
    Device.motionSupported = false
  }

  export let episode
  
  let skipToInstrument = false
  if(episode == "none"){
    skipToInstrument = true
  }

  Audio.staticFilesPath = episode.staticFilesPath || $staticPath

  let stateFlags = {
    didFinishHistoryVideo: false,
    didAcknowledgePrivacyStatement: false,
    didTestAudio: false,
    didEnableAudio: false,
    didEnableMotion: false,
    didEnableKeyboard: false,
    didTestKeyboard: false,
    needsToEnableMotionInSettings: false,
    didFinishEpisodeDeck: false,
    didFinishInstructionalVideo: true,
    playModeActive: false,
    isMuted: true,
    showControls: false,
    showManualControls: false
  }

  onDestroy(() => {
    // console.log('bye')
  })
  
  let stopSubcomponents = false
  export let basepath

  // $: if(skipToInstrument){
  //   stateFlags.didFinishCalibration = true
  //   stateFlags.didFinishVideo = true
  //   stateFlags.playModeActive = true

  //   if(!stateFlags.didEnableMotion){
  //     enableMotion(Device)
  //       .then( () => { 
  //         stateFlags.didEnableMotion = true 
  //         if(!stateFlags.didEnableAudio){
  //           Audio.enable()
  //             .then( () => {
  //               stateFlags.didEnableAudio = true
  //               stateFlags.didTestAudio = true
  //               stateFlags.isMuted = false
  //             })
  //             .catch( error => console.log(error))
  //         }
  //       })
  //       .catch( error => {
  //         if(error.code === undefined || error.code == null){
  //           throw error
  //         }

  //         switch(error.code){
  //           case "03":
  //             // might be a desktop browser faking a little too well, let's give 'em an out

  //             break
  //           case "04":
  //             // safari 12.2 - 12.4
  //             stateFlags.needsToEnableMotionInSettings = true
  //             break
  //           default:
              
  //         }
  //       })
  //   }
  // }

  let metrics = {
    tightLoopDuration: 0 //ms
  }
  
  let visualizerParams
  $: if(!stateFlags.didFinishEpisodeDeck){
    visualizerParams = {
      contrast: 0.9,
      max: 5,
      gamut: 20
    }
  } else {
    visualizerParams = {
      contrast: 0.5,
      max: 5,
      gamut: 255
    }
  }
  
  let introSlides = [{
    content: "<p><strong>Surveillance-Free Zone: </strong>This site asks for some permissions to work properly, but it doesn't transmit, record, or store anything.</p>",
    contentPOV: "object",
    btnNext: { 
      label: "Okay",
      canAdvance: function(){
        return new Promise( resolve => {
          stateFlags.didAcknowledgePrivacyStatement = true
          resolve()
        })
      }
    }
  }]
  
  if(episode != "none"){
    let addedSlides = [{
      content: "<p>In this episode, you'll learn a bit about the history of Japanese taiko drumming, tune your virtual taiko, and then learn and play a piece of music.</p>",
      contentPOV: "object",
      btnNext: { 
        label: "Got it — let's go!"
      }
    },{
      contentSrc: episode.contextVideo.contentSrc,
      captionSrc: episode.contextVideo.captionSrc,
      contentPOV: "video",
      btnNext: {
        canAdvance: function(){
          return new Promise( resolve => {
            stateFlags.didFinishHistoryVideo = true
            resolve()
          })
        }
      }
    }]
    introSlides.push(...addedSlides)
  }

  let soundCheckSlides = [{
    content: `<p>
    Let's make sure you can hear me...
    </p>
    <p class="small left-justified">
    - make sure your device is not on vibrate<br/>
    - check that your volume is turned up<br/>
    - use wired headphones only — no bluetooth!<br/>
    - try reloading this page
    </p>
    `,
    contentPOV: "first-person",
    btnNext: { 
      label: "I'm ready — play a sound",
      canAdvance: function(){
        return new Promise( (resolve, reject) => {
          return Audio.enable()
            .then( () => {
              stateFlags.didTestAudio = true // is this flag really necessary?
              resolve()
            })
            .catch(error => reject(error) )
        })
      }
    }
  },{
    content: 'Did you hear that?',
    contentPOV: "first-person",
    btnPrev: {
      label: "No"
    },
    btnNext: { 
      label: "Yes",
      canAdvance: function(){
        return new Promise( (resolve, reject) => {
          stateFlags.didEnableAudio = true
          resolve()
        })
      }
    }
  }]

  let motionTuningSlides = [{
      content:`<p>You can play this virtual taiko with your hands, or you can find something in your home to use as drumsticks. Rolled-up magazines, (you can tape them so they stay rolled), wooden spoons or spatulas, paper towel rolls... make your choice and get ready!</p>`,
      contentPOV: "first-person",
      btnNext: {
        label: "Okay, ready to go!"
      }
    },{
      content:`<p>If you have a case or PopSocket-style attachment on your device, you'll probably have better results if you remove it now.</p>`,
      contentPOV: "first-person",
      btnNext: {
        label: "Got it"
      }
    },{
      slideClass: "drift-spin",
      content: `<p>It feels very floaty in here, I'm not sure which way is up...</p>`,
      contentPOV: "first-person",
      btnNext: { 
        label: "Enable motion tracking",
        canAdvance: function(){
          return new Promise( (resolve, reject) => {
            return enableMotion(Device)
              .then( () =>{
                stateFlags.didEnableMotion = true
                resolve()
              })
              .catch( (error) => reject(error) )
          })
        },
        onError: function(error) {
          if(error.code === undefined || error.code == null){
            throw error
          }

          switch(error.code){
            case "03":
              console.log(error)
              // might be a desktop browser faking a little too well, let's give 'em an out (this is a hacky workaround)
              let reload = confirm("I've made a huge mistake. I'm going to start you over and this won't happen next time. Error code 3")

              if(reload){
                window.location = window.location + "?keyboard"
              }

              break
            case "04":
              console.log(error)
              // safari 12.2 - 12.4
              stateFlags.needsToEnableMotionInSettings = true
              break
            default:
              console.log(error)
          }
        }
      }
    },{
      content: `<p>Phew! That's better, but can you put me down flat on a surface?</p>`,
      // transitionalContent:`<p>Give me a couple seconds to feel the stillness...</p>`,
      contentPOV: "first-person",
      btnNext: { 
        label: "Done!",
        canAdvance: function(){
          return new Promise( resolve => {
            stateFlags.playModeActive = true
            return captureMotionInput(4000, 0).then( results => {
              console.log(results)
              motionNoiseFloor = Math.abs(results.max) * 1.1
              resolve() 
            })
          })
        }
      }
    },{
      content: `<p>Now I want you to press Okay and then give the surface your device is on four hard strikes.</p>`,
      // transitionalContent:`<p>Listening for your forceful strikes...</p>`,
      contentPOV: "first-person",
      btnNext: {
        label: "Okay",
        canAdvance: function(){
          return new Promise( resolve => {
            return captureMotionInput(4000, 4).then( results => {
              console.log(results)
              motionMax = results.max * 1.5
              resolve() 
            })
          })
        }
      }
    },{
      content: `<p>Next, press Okay and then give the surface your device is on four soft & gentle strikes.</p>`,
      // transitionalContent:`<p>Listening for your soft & gentle strikes...</p>`,
      contentPOV: "first-person",
      btnNext: {
        label: "Okay",
        canAdvance: function(){
          return new Promise( resolve => {
            return captureMotionInput(4000, 4).then( results => {
              console.log(results)
              motionThresholdFloor = results.probablePeaks[0]
              stateFlags.isMuted = false
              stateFlags.showControls = true
              resolve() 
            })
          })
        }
      }
    },{
      content:`<p>Strike the surface your device is sitting on once. You should hear a drum stroke! You can mute your taiko with the mute button. The other button opens the tuning controls.</p>`,
      contentPOV: "first-person",
      btnNext: { 
        label: "Okay"
      }
    },{
      content:`<p>Now that you've tuned your taiko, you can play along with me in the next video!</p>`,
      contentPOV: "first-person",
      btnNext: { 
        label: "Let's go!"
      }
    }
    // ,{
    //   content:`<p>There are two things you can tune: Drumming Force, and Time Between Beats. Strike your surface: if you hear more than one drum hit, try turning up Drumming Force until one strike produces a single sound. If you don't hear any sound, turn down Drumming Force until you hear a sound when you strike your surface.</p>`,
    //   contentPOV: "first-person",
    //   btnNext: { 
    //     label: "Done"
    //   }
    // },{
    //   content:`<p>Try a few strikes in sequence. If some of your strikes don't produce sound, try lowering Time Between Beats.</p>`,
    //   contentPOV: "first-person",
    //   btnNext: { 
    //     label: "Done!"
    //   }
    // }
  ]

  let keyboardTuningSlides = [{
    content: `<p>I'll set you up to play using your keyboard. Let's tune your taiko!</p>`,
    contentPOV: "first-person",
    btnNext: {
      label: "Alright!",
      canAdvance: function(){
        return new Promise( resolve => {
          stateFlags.didEnableKeyboard = true
          stateFlags.playModeActive = true
          stateFlags.showControls = true
          resolve()
        })
      }
    }
  },{
    content: `<p>Click the sound button to unmute, then strike any key on your keyboard. Do you hear a drumbeat?</p>`,
    contentPOV: "first-person",
    btnNext: {
      label: "Yes",
      canAdvance: function(){
        return new Promise( resolve => {
          stateFlags.didTestKeyboard = true
          resolve()
        })
      }
    }
  },{
    content: `<p>Now strike two or three keys at the same time. It should sound louder than when you strike a single key, yeah?</p>`,
    contentPOV: "first-person",
    btnNext: {
      label: "Yeah, a bit...",
      canAdvance: function(){
        return new Promise( resolve => {
          stateFlags.showManualControls = true
          resolve()
        })
      }
    }
  },{
    content: `<p>Increasing 'Keymash' will make this difference bigger — so the more keys you press, the louder the drumbeat.</p><div class="spacer"></div><p>Try raising it to 0.5 and see for yourself. Then set it somewhere that sounds good to you.</p>`,
    contentPOV: "first-person",
    btnNext: {
      label: "Okay, did that"
    }
  },{
    content: `<p>Click the 'X' button to hide the tuning controls for now. </p><div class="spacer"></div><p>Now that you've tuned your taiko, you can play along with me in the next video!</p>`,
    contentPOV: "first-person",
    btnNext: {
      label: "Let's go!"
    }
  }]

  let instructionalSlides 
  if(episode != "none"){
    instructionalSlides = [{
      contentSrc: episode.instructionalVideo.contentSrc,
      contentTextTrack: episode.instructionalVideo.captionSrc,
      contentPOV: 'video-instructional',
      btnNext: {
        canAdvance: function(){
          return new Promise( resolve => {
            stateFlags.didFinishInstructionalVideo = true
            resolve()
          })
        }
      }
    },{
      content: `<p>That's it for this episode! You can drum freely now for as long as you want. Thanks for trying out Virtual Taiko.</p>`,
      contentPOV: 'first-person',
      btnNext: {
        label: "Bye!"
      }
    }]
  } else {
    instructionalSlides = [{
      content: `<p>That's it for tuning! You can drum freely now for as long as you want. Thanks for trying out Virtual Taiko.</p>`,
      contentPOV: 'first-person',
      btnNext: {
        label: "Okay!"
      }
    }]
  }
  
  let episodeDeck = {
    title: "",
    slides: []
  }

  if(episode != "none"){
    episodeDeck.title = episode.title
  }

  episodeDeck.slides.push(...introSlides)
  episodeDeck.slides.push(...soundCheckSlides)

  // branching paths (motion vs. keyboard)
  if(Device.motionSupported){
    episodeDeck.slides.push(...motionTuningSlides)
    episodeDeck = episodeDeck // for svelte...
  } else {
    episodeDeck.slides.push(...keyboardTuningSlides)
    episodeDeck = episodeDeck // for svelte...
  }
  
  episodeDeck.slides.push(...instructionalSlides)

  episodeDeck = episodeDeck

  // set uids for slides
  episodeDeck.slides.map( (slide, index) => {
    slide.id = "" + episodeDeck.title + "_slide_" + index
    return slide
  })

  let episodeDeckTransitionApprovedToIndex = 0

  let onEpisodeDeckTransitionRequested = function(event){
    const index = event.detail.fromSlideIndex
    const id = event.detail.slideId
    const directionForward = event.detail.directionForward

    const advance = function(forward){
      if(forward){
        episodeDeckTransitionApprovedToIndex = index + 1 // implicit cast from string to int here
      } else {
        episodeDeckTransitionApprovedToIndex = -1
      }
    }

    const slide = episodeDeck.slides.find( slide => slide.id == id)

    if(slide == null || slide === undefined){
      throw new Error("Failed to advance to next slide")
      return
    }

    let canAdvance = slide.btnNext.canAdvance ||  function(){ 
      return new Promise(resolve => {
        resolve()
      })
    }

    const onError = slide.btnNext.onError || function(error){ 
      console.log(error)
    }


    canAdvance()
      .then( () => {
        advance(directionForward)
      })
      .catch(error => {
        onError(error)
      })
  }
  
  let onEpisodeDeckEndReached = function(){
    stateFlags.didFinishEpisodeDeck = true
  }
  
  let onMuteButton = function() {
    stateFlags.isMuted = !stateFlags.isMuted;
  }

  let onShowControlsButton = function(){
    stateFlags.showManualControls = !stateFlags.showManualControls
  }

  // const onBackBtn = function(){
  //   // hacked workaround 
  //   // for some reason 'onDestroy' never fires on this component
	// 	window.location = window.location
  // }

/* KEYBOARD */
  const keyboardBaseGain = 0.5
  const keyboardMaxGain = 5 // do we need this if we have a limiter node?
  let keyboardGainFactor = 0.2

  const onKeyboardStrokeUpdate = function(event){
    const keysPressed = event.detail.keysDown
    const gain = keyboardBaseGain + keysPressed * keyboardGainFactor
    const clampedGain = gain > keyboardMaxGain ? keyboardMaxGain : gain
    Audio.updateGainOnLastStroke(clampedGain)
  }

  const onSpacebar = function(){
    console.log("pause video")
  }

/*	 
 * MOTION
 */
  // motion algorithm parameters
  let cooldown = 50
  let motionNoiseFloor = 0.4
  let motionMax = 3
  
  let motionThresholdFloor = 1
  let motionThreshold = new Audio.Tone.Signal(motionThresholdFloor)
  let motionPeak = { passed: false, sign: -1 }
  let motionZeroCrossings = 0
  
  let motionBuffer = new CBuffer(256).fill( () => {
    let val = (Math.random() * 10) - 5
    return {
      zAcc: val,
      interval: 0,
      noiseFloor: motionNoiseFloor,
      thresholdFloor: motionThresholdFloor,
      threshold: motionThreshold.value
    }
  })
  motionBuffer = motionBuffer // for svelte (triggers onchange)

  let lastMotionEvent
  $: lastMotionEvent = motionBuffer.last()

  let enableMotion = function(device){
    console.log(device)
    let error
    return new Promise( async (resolve, reject) => {
      
      // sad path: no accelerometer
      if(!device.motionSupported){
        error = new Error()
        error.code = "01"
        error.message = errorCodes[error.code]
        reject(error)
      }

      if(device.isIOS && device.os.majorVersion >= 13){
        // happy path: iOS 13
        // console.log("motion / ios 13")
        let permissionStatus
        try {
          permissionStatus = await window.DeviceMotionEvent.requestPermission()
        }
        catch(err){
          err.code = "00"
          reject(err) // pass through to keep stack trace
        }

        if(permissionStatus == "granted"){
          try {
            await trackMotion(onDeviceMotionEvent)
          } catch(err) {
            reject(err)
          }

          resolve()
        } else {
          error = new Error()
          error.code = "02"
          error.message = errorCodes[error.code]
          reject(error)
        }
      } else {

        // happy path: android, iOS < 12.2, iOS 12.2 - iOS 12.4
        try {
          await trackMotion(onDeviceMotionEvent)
        } catch(err) {
          // sad path: iOS 12
          if(device.isIOS && 
            device.os.majorVersion >=12 && device.os.majorVersion < 13 &&
            device.os.minorVersion >= 2){
            
            error = new Error()
            error.code = "04"
            error.message = errorCodes[error.code]
            reject(error)
          } else {
            // might be a desktop browser faking a little too well
            reject(err)
          }
        }

        resolve()
      }

    })
  }

  var didReceiveOneMotionEvent = false

  let trackMotion = function(motionHandler){
    let error
    return new Promise( async (resolve, reject) => {
      window.addEventListener('devicemotion', onFirstDeviceMotionEvent)

      await delay(250)
      
      window.removeEventListener('devicemotion', onFirstDeviceMotionEvent)
      
      if(didReceiveOneMotionEvent){
        window.addEventListener('devicemotion', motionHandler)
        resolve()
      } else { 
        error = new Error()
        error.code = "03"
        error.message = errorCodes["03"]
        reject(error)
      }
    })
  }

  let onFirstDeviceMotionEvent = function(){
    didReceiveOneMotionEvent = true
  }

  let tightLoopStartTime

  let onDeviceMotionEvent = function(event){
    tightLoopStartTime = performance.now()

    const sample = { zAcc: event.acceleration.z, interval: event.interval * 1000, noiseFloor: motionNoiseFloor, thresholdFloor: motionThresholdFloor, threshold: motionThreshold.value }
    
    if(!stateFlags.isMuted){
      const lastSample = motionBuffer.last()
      const absZ = Math.abs(sample.zAcc)

      if(absZ > sample.threshold){
        if(motionPeak.passed == true && motionPeak.sign != Math.sign(sample.zAcc)){
          // - this sample is probably a rebound? i.e. part of the previous stroke. 
          // NB it's not necessarily "the" negative / second peak, a sample could exceed threshold and still have further samples before reaching the negative peak

          // console.log('stroke "end"')
          // start the cooldown
          motionThreshold.exponentialRampToValueAtTime(motionThresholdFloor, "+" + cooldown/1000)

          // reset
          motionPeak.passed == false
        }

        if(Math.abs(lastSample.zAcc) <= lastSample.threshold /*&& !motionClampedToZero*/ ){	
          // this is a stroke beginning, and this is the first sample from that stroke that exceeds the threshold
          // console.log('stroke start')
          motionZeroCrossings = 0
          
          Audio.playTaikoHit(absZ)
          
          // raise the motion threshold for subsequent frames
          motionThreshold.setValueAtTime(absZ * 1.2, "+" + sample.interval/1000 / 3)

        } else { 
          if(absZ > Math.abs(lastSample.zAcc)){
            // - this sample is after the beginning of the stroke but the slope is still increasing

            // console.log("stroke +")
            // increase gain to match
            // strokeGainNode.setValueAtTime(absZ, "+" + event.interval /* in seconds, in Safari! */ / 3)

            // raise the motion threshold for subsequent frames
            motionThreshold.setValueAtTime(absZ * 1.2, "+" + sample.interval/1000  / 3)

          } 
        }
      } else {
        // - this sample did not exceed the current threshold
        if(Math.abs(lastSample.zAcc) >= lastSample.threshold ){
          // - but the previous sample was a stroke start or slope increase

          if(absZ <= Math.abs(lastSample.zAcc)){
            // - this sample is coming right after a slope increase, but the new slope is flat or negative
            // in other words, this is our first peak

            // console.log("stroke peak 1")

            motionPeak.passed = true
            motionPeak.sign = Math.sign(sample.zAcc)
          }
        } else if(Math.sign(lastSample.zAcc) != Math.sign(sample.zAcc)){
          // - it's a zero crossing!

          // console.log("stroke zero crossing")
          motionZeroCrossings ++

          if(motionZeroCrossings == 2){
            // start the cooldown
            motionThreshold.exponentialRampToValueAtTime(motionThresholdFloor, "+" + cooldown/1000)

            // reset
            motionPeak.passed == false
            motionZeroCrossings = 0

            // console.log("stroke 'end'")
          }
        }
      }
    }

    motionBuffer.push(sample)
    motionBuffer = motionBuffer // to trigger svelte to update

    metrics.tightLoopDuration = performance.now() - tightLoopStartTime
  }
  
  const errorCodes = {
    "00": "Underlying error",
    "01": "Motion is not supported on this hardware",
    "02": "User declined permission for motion & orientation access",
    "03": "Failed to enable motion: unknown error",
    "04": "iOS 12.2-12.4 requires user to enable motion & orientation tracking in Settings > Safari"
  }

  let captureMotionInput = function(timespan, expectedNumberOfStrokes){
    return new Promise( async resolve => {
      await delay(timespan)

      const samples = motionBuffer.toArray()
        .map( datum => Math.abs(datum.zAcc))
      
      let probablePeaks = null
      
      if(expectedNumberOfStrokes !== undefined && expectedNumberOfStrokes > 0){
        const sortedSamples = samples
        .sort( (a, b) => a -b )
        probablePeaks = sortedSamples.slice(-expectedNumberOfStrokes)
      }

      const results = { max: max(samples), mean: mean(samples), probablePeaks: probablePeaks}

      resolve(results)
    })
  }

  let onThresholdFloorChanged = function(event){
    motionThresholdFloor = event.detail.value
    motionThreshold.setValueAtTime(motionThresholdFloor, 0)
  }

  /* UTILITIES */
  const delay = function(time){ // time in ms
    return new Promise( resolve => setTimeout(resolve, time))
  }

  let randomAmplitude 
  setInterval( function(){
    randomAmplitude = Math.random()
  }, 1/30)

</script>

<main>
  <section id="instrument" transition:fade={{duration:250}}>

    <div class="layer centering-layer" id="visualizer">
      <!-- <RadialVisualizer ringCount={16} data={motionBuffer}
        contrast={visualizerParams.contrast}
        max={visualizerParams.max}
        gamut={visualizerParams.gamut}
      /> -->
      {#if stateFlags.didEnableMotion}
        <RadialAmplitudeVisualizer datum={ lastMotionEvent } max={motionMax} />
      {/if}
    </div>
    
    {#if episode != "none"}
      <img id="avatar" srcset={episode.avatar.src + "@1x.png 1x, " + episode.avatar.src + "@2x.png 2x"} src={episode.avatar.src + "@1x.png"} alt={episode.avatar.altText}>
    {/if}

    {#if !Device.didEnableKeyboard }
      <KeyboardInputHandler disabled={stateFlags.isMuted} on:go={ e => {
        Audio.playTaikoHit(keyboardBaseGain)
      }}
      on:update={ onKeyboardStrokeUpdate }
      on:spacebar={ onSpacebar }
      />
    {/if}
    {#if !stateFlags.didFinishEpisodeDeck}
      <div class="layer centering-layer">
        <DeckViewer 
          deck={episodeDeck} 
          on:transitionRequested={onEpisodeDeckTransitionRequested}
          transitionApprovedToIndex={episodeDeckTransitionApprovedToIndex}
          on:deckEndReached={onEpisodeDeckEndReached}
          kill={stopSubcomponents}
        />
      </div>
    {:else}
      <div class="layer centering-layer bottom">
        <a class="scores-link" href={$staticPath + "/pdfs/Virtual_Taiko_Rhythms.pdf"} target="_blank">View / print drumming patterns</a>
      </div>
    {/if}
    
    {#if stateFlags.playModeActive && stateFlags.showControls}
      <div class="layer passthrough">
        <div class="controls" transition:fade={{ duration:250 }}>
          <button type="button" class="btn-image { !stateFlags.isMuted ? "btn-mute" : "btn-volume-on"}" on:click={onMuteButton}>
            <span class="label">{ !stateFlags.isMuted ? "Mute" : "Unmute"}</span>
          </button>

          <button type="button" class="btn-image { !stateFlags.showManualControls? "btn-controls" : "btn-close"}" on:click={onShowControlsButton}>
            <span class="label">{ !stateFlags.showManualControls? "Show manual controls" : "Hide manual controls"}</span>
          </button>
        </div>
        {#if stateFlags.showManualControls && stateFlags.didEnableMotion }
          <div class="manual-controls motion" transition:fade={{ duration:250 }}>
            <Stepper label={"Drumming force"} initialValue={motionThresholdFloor} step={0.1} digits={1} incrementLabel={"Harder"} decrementLabel={"Softer"} on:valueChanged={ onThresholdFloorChanged }/>
            <Stepper label={"Time between beats"} initialValue={cooldown} unit={"ms"} step={10} digits={0} incrementLabel={"Slower"} decrementLabel={"Faster"} on:valueChanged={ e => cooldown = e.detail.value }/>
          </div>
        {:else if stateFlags.showManualControls && stateFlags.didEnableKeyboard}
          <div class="manual-controls keyboard" transition:fade={{ duration:250 }}>
            <Stepper label={"Keymash"} initialValue={keyboardGainFactor} step={0.1} digits={1} incrementLabel={"Louder"} decrementLabel={"Quieter"} on:valueChanged={ e => { keyboardGainFactor = e.detail.value }}/>
          </div>
        {:else if stateFlags.showManualControls }           
          <p>Hmm, it looks like you have no way of drumming. Did you enable motion tracking or keyboard playiong? Or something went wrong on our end. Try <a href="">reloading this website.</a></p>
        {/if}
      </div>
    {/if}

    <button type="button" class="btn-image btn-back" on:click={ async e => {
      stopSubcomponents = true
      await delay(200)
      activePage.set({page:"home"})
    }}><span class="label">Back</span></button>
    
    <!-- <div class="top-left-corner">
      <Link to="/">Back</Link>
    </div> -->

    {#if stateFlags.needsToEnableMotionInSettings}
      <div class="layer centering-layer opaque" transition:fade={{duration: 250 }}>
        <div class="wrapper pov-first-person">
          <p>Hmm, I still can't tell which way is up! Let's fix that. On your device:
          <ol class="small">
            <li>open the Settings app</li>
            <li>scroll down and tap 'Safari'</li>
            <li>scroll down until you see <span class="small-caps">privacy & security</span></li>
            <li>toggle "Motion & Orientation Access" to ON</li>
            <li>come back here and <a href="">reload this website</a></li>
          </ol>
          <video class="inline-screencap" src="{ episode.videoFilesPath + "/ios12-settings-demo.mp4"}" width="374" height="374" autoplay muted playsinline loop />
        </div>
      </div>
    {/if}
  </section>
</main>

<style>
  section#instrument {
    background-image: url(./../static/images/drum-texture-colour.jpg);
    background-size: cover;
  }

  .layer {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }

  .layer.opaque {
    background-color: #eee;
  }

  .layer.centering-layer {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .layer.centering-layer.bottom {
    flex-direction: column;
    justify-content: flex-end;
  }
  
  .layer.passthrough {
    pointer-events: none;
  }

  :global(.layer.passthrough button), 
  :global(.layer.passthrough a),
  :global(.layer.passthrough div.stepper) {
    pointer-events: auto;
  }
  
  .layer > .wrapper {
    width: 100%;
  }

  .layer > .wrapper > p {
    margin: 0 10px;
  }
  
  .controls {
    position: absolute;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
  
  .controls > button {
    margin-bottom: 0;
  }

  .manual-controls {
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
  }

  :global(.manual-controls .stepper) {
    width: 225px;
  }

  button.btn-back {
    position: absolute;
    top: -65px;
    left: -65px;
    min-width: 130px;
    min-height: 130px;
    background-position: 85% 85%;
  }

  .top-left-corner {
    position: absolute;
    top: 20px;
    left: 20px;
  }

  #avatar {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    width: 20vw;
  }

  @media(orientation: portrait){
    video.circle-framed {
      height: 50vh;
      width: auto;
    }

    :global(.manual-controls .stepper:not(:last-child)) {
      margin-bottom:2rem;
    }
    
    .controls {
      width: 100vw;
      top: 2rem;
      flex-direction: row;
    }

    .manual-controls {
      width: 100vw;
      justify-content: space-between;
    }

    .manual-controls.motion {
      bottom: 15vh;
    }

    .manual-controls.keyboard {
      bottom: 15vh;
    }

    #avatar {
      width: 20vh;
    }
  }

  @media(orientation: landscape){
    video.circle-framed {
      width: 50vw;
      height: auto;
    }
    
    .controls {
      height: 100vh;
      right: 2rem;
      flex-direction: column;
    }

    .manual-controls {
      height: 100vh;
      width: 225px;
      left: 2rem;
      justify-content: space-evenly;
    }

    #avatar {
      width: 20vw;
    }

    .scores-link {
      margin-bottom: 2em;
    }
  }
  
</style>